import { useState, useEffect } from "react";
import { Card, OverlayTrigger, Tooltip } from "react-bootstrap";
import { EntityType } from "../utils/types";

interface EntityLegendProps {
  entityTypes: string[];
  onSelectEntity: (entity: string) => void;
  isDeAnnotateMode: boolean;
  ENTITY_COLORS: Record<EntityType, string>;
  ENTITY_BORDER_COLORS: Record<EntityType, string>;
  // Add this prop to refresh when custom entities change
  customEntitiesVersion?: number;
}

export default function EntityLegend({
  entityTypes,
  onSelectEntity,
  isDeAnnotateMode,
  ENTITY_COLORS,
  ENTITY_BORDER_COLORS,
  customEntitiesVersion = 0,
}: EntityLegendProps) {
  // State to hold the latest entity types
  const [currentEntityTypes, setCurrentEntityTypes] =
    useState<string[]>(entityTypes);

  // Update when either entityTypes prop changes or customEntitiesVersion changes
  useEffect(() => {
    setCurrentEntityTypes(entityTypes);
  }, [entityTypes, customEntitiesVersion]);

  return (
    <Card className="shadow-sm border-0">
      <Card.Header className="bg-white border-bottom py-3">
        <h5 className="mb-0">Entity Legend</h5>
      </Card.Header>
      <Card.Body>
        <div className="d-flex flex-wrap gap-2">
          {currentEntityTypes.map((type) => (
            <OverlayTrigger
              key={type}
              placement="top"
              overlay={<Tooltip>{type}</Tooltip>}
            >
              <div
                className="border rounded p-2 text-center"
                style={{
                  backgroundColor:
                    ENTITY_COLORS[type as EntityType] || "#e9ecef", // Fallback color
                  borderColor:
                    ENTITY_BORDER_COLORS[type as EntityType] || "#ced4da", // Fallback border
                  width: "70px",
                  cursor: isDeAnnotateMode ? "default" : "pointer",
                  fontSize: "11px",
                  fontWeight: "bold",
                  color:
                    type === "SPECIES" || type === "CHEMICAL"
                      ? "black"
                      : "rgba(0,0,0,0.7)",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
                onClick={() => {
                  if (!isDeAnnotateMode) {
                    onSelectEntity(type);
                  }
                }}
                title={type}
              >
                {type}
              </div>
            </OverlayTrigger>
          ))}
        </div>
      </Card.Body>
    </Card>
  );
}
